import React from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import ChevronLeft from "../common/icons/ChevronLeft";

type $Props = {
  handlePrevious: method,
};

const GalleryPrevious = ({ classes, className, handlePrevious }: $Props) => (
  <button
    onClick={handlePrevious}
    className={classNames(classes.root, className)}
  >
    <ChevronLeft style={{ marginRight: "4px" }} width={32} height={28} />
  </button>
);

export default withStyles((theme) => ({
  root: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    left: "10px",
    width: "44px",
    height: "44px",
    color: "white",
    padding: theme.spacing.unit * 0.5,
    background: "rgba(0,0,0,0.4)",
    borderRadius: theme.globalBorderRadius,
    top: "calc(50% - 36px)",

    [theme.breakpoints(900)]: {
      top: "calc(50% - 111px)",
    },
  },
}))(GalleryPrevious);
